<!-- Modal Container -->
<template>
  <transition name="modal-fade" class="modal-fade">
    <div class="modal-backdrop">
      <form  action="#"  method="post">
      <div class="report-modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
        <header class="modal-header">
          <slot name="header">           
            <i class="fa fa-bar-chart report-icon" aria-hidden="true"></i>&nbsp;&nbsp;{{title}}
            <div class="closeButton">
            </div>
          </slot>
        </header>
<section class="report-modal-body" style="padding-bottom: 0px;">

					<div class="campaign-details margin-bottom-10px">
						<div>Reengagement Name: <span class="campaign-details-text">{{this.campaignDetails.campaign_name ? this.campaignDetails.campaign_name : '-'}}</span></div>
						<div>Country: <span class="campaign-details-text">{{this.campaignDetails.country ? this.campaignDetails.country : '-'}}</span></div>
						<div>Type: <span class="campaign-details-text">{{this.campaignDetails.campaign_type ? this.campaignDetails.campaign_type : '-'}}</span></div>
						<div>Audience: <span class="campaign-details-text">{{this.campaignDetails.audience_name ? this.campaignDetails.audience_name : '-'}}</span></div>
					</div>

					<div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
						<div class="panel panel-primary panel-reengagement-group" v-for="(item, index) in this.campaignDetails.group_list" :key="index" >
							<div class="panel-heading padding-0" role="tab" :id="'heading'+index">
								<h3 class="text-center panel-title">
									<a role="button" :href="'#content'+index" data-toggle="collapse"  data-parent="#accordion" :aria-controls="'content'+index" aria-expanded="false" class="collapsable-link-panel collapsable-link-panel-child">
										<div><span class="campaign-details-text">{{item.group_name ? item.group_name : '-'}}</span></div>
									</a>
								</h3>
							</div>
							<div :id="'content'+index" class="panel-collapse collapse" role="tabpanel" :aria-labelledby="'heading'+index">
								<div class="panel-body">
									<div class="campaign-group-details" style="display: flex; flex-direction: column; margin-bottom: 10px;">
											<div>Nudge: <span class="campaign-details-text">{{item.msg_template_name ? item.msg_template_name : '-'}}</span></div>
											<div v-if="item.conversation">Conversation: <span class="campaign-details-text">{{item.conversation ? item.conversation : '-'}}</span></div>
											<div v-else>Keyword: <span class="campaign-details-text">{{item.keyword ? item.keyword : '-'}}</span></div>
											<div>Destination: <span class="campaign-details-text">{{item.destination_app_name ? item.destination_app_name : '-'}}</span></div>
											<div>Split Percent: <span class="campaign-details-text">{{item.split_percent || item.split_percent === 0 ? item.split_percent + '%' : '-'}}</span></div>
									</div>

									<div>
									<div class="row margin-top-10">
										<!-- Message failed Div -->
										<div class="col-xl-3 col-md-6 mb-4">
												<div class="card border-left-red shadow h-100 py-2">
														<div class="card-body">
																<div class="row no-gutters align-items-center">
																		<div class="col mr-2">
																				<div class="text-sm font-weight-bold text-red text-uppercase mb-1">
																						Messages Failed</div>
																				<div class="heading-style text-lg mb-0 font-weight-bold text-gray-800">{{reengagementReport[index].messagesFailed	}}</div>
																		</div>
																		<div class="col-auto">
																				<i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
																		</div>
																</div>
														</div>
												</div>
										</div>
										<!-- Message failed Div END-->
										<!-- Message failed reason Div -->
										<div class="col-xl-3 col-md-6 mb-4">
												<div class="card border-left-red shadow h-100 py-2">
														<div class="card-body">
																<div class="row no-gutters align-items-center">
																		<div class="col mr-2">
																				<div class="text-sm font-weight-bold text-red text-uppercase mb-1">
																						Messages Failed Reason</div>

																					<div class="failed-reason-div">
																						<div class="text-sm text-gray-800" v-for="reason in reengagementReport[index].messagesFailedReasons" :key="reason.msg_failure_reason">
																							<b>USERS:</b>{{reason.count}} <b style="margin-left: 10px">ERROR:</b>{{reason.msg_failure_reason}}
																						</div>
																						<div v-if="!reengagementReport[index].messagesFailedReasons.length" class="text-lg text-gray-800"> - </div>
																					</div>
																		</div>
																		<div class="col-auto">
																				<i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
																		</div>
																</div>
														</div>
												</div>
										</div>
										<!-- Message failed reason Div END-->
									</div>
									</div>
								</div>
							</div>
						</div>

					</div>

        </section>
        <footer class="modal-footer">
            <slot name="footer">
              <button type="button" class="btn btn-primary" @click="close">Close</button>
            </slot>
        </footer>
      </div>
      </form>
    </div>
  </transition>
  <!-- Modal Container end -->
</template>
<script>
  export default {
    name: 'modal',
    props: [ 'reengagementReport', 'campaignDetails' ],
    data () {
      return {
        title: 'Reengagement Details'
      }
    },
    methods: {
      close () {
        console.log('closing the modal')
        this.$emit('close')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// failedReport.vue?9cd8fdc2